<template>
  <div class="thin-scroll">
    <template v-if="displayTitle">
      <base-card-title expanded>
        {{ displayTitle ? $t('inventory.title') : '\xa0' }}
      </base-card-title>
    </template>
    <div v-if="selectedFacets.length > 0" class="catalog_sortby" :style="`${!showFilterChips && responsive.lg || hideFilterChips ? 'justify-content: end; margin-bottom: 12px' :'justify-content: space-between'}`">
      <!-- Removing loading skeleton for search bar -->
      <!-- <template v-if="loading && !hideFilterChips">
        <base-skeleton>
          <div class="">
            <div
              class="skeleton__item"
              style="width: 320px"
            />
            <div class="skeleton__item mt-2" style="width: 120px" />
          </div>
        </base-skeleton>
      </template> -->

      <template>
        <base-transition-expand speed="fast">
          <div v-if="showFilterChips || (!responsive.lg && showFilterButton)" class="d-inline-flex align-center">
            <base-button
              v-if="!responsive.lg && showFilterButton "
              small
              text
              class="catalog-product-list__filter-btn"
              style="justify-content: start"
              @click="$emit('toggle-filter-drawer')"
            >
              <base-icon icon="filter" class="mr-1" />Filter
            </base-button>
            <div v-if="showFilterChips && responsive.lg && showFilterTags" style="margin-left: 3px;">
              <div class="catalog-product-list__filter">
                <span class="filter_count">
                  {{ numResults }} results
                </span>
                <div>
                  <template v-for="(filter, index) in filtersLimited">
                    <slot name="filters" :index="index" :filter="filter">
                      <base-chip
                        :key="index" :label="filter"
                        @delete="$emit('delete', filter)"
                      />
                    </slot>
                  </template>
                  <div class="catalog-product-list__clear-btn" @click="$emit('clear')">
                    Clear all
                  </div>
                </div>

                <!-- <div class="catalog-product-list__clear-btn" @click="$emit('clear')">
                  Clear all
                </div> -->
              </div>
            </div>
          </div>
        </base-transition-expand>
      </template>
      <div
        :class="`${!showFilterChips ? 'ml-auto' : ''}`"
        style="display: inline-flex; position: relative;"
        :style="`${showSearch ? 'width: 100%;':''}`"
      >
        <!-- icon search -->

        <base-button
          v-if="!showSearch"
          small
          text
          @click="btnSearch"
        >
          <base-icon icon="search" class="mr-1" />
        </base-button>
        <!-- search -->
        <transition name="fade">
          <base-search
            v-if="showSearch"
            icon-position="left"
            :value="search"
            class="search_button"
            has-cancel-search="true"
            focus-on-mount="true"
            @input="onSearch"
            @cancelSearch="cancelSearch"
          />
        </transition>
        <!-- Already present in base-search. Multiple icons were showing -->
        <!-- <base-icon
          v-if="showSearch"
          icon="x-circle-grey"
          class="position-absolute action-close"
          :class="!isSorted ? 'action-close-sort' : '' "
          @click="cancelSearch"
        /> -->
        <slot name="right" />
      </div>
    </div>
    <div
      v-if="selectedFacets.length > 0"
      v-scrollable="{
        heightThresholdAdjust: 20,
        noPixel: true,
      }"
      :class="{ 'catalog-product-list__grid--scrollable': scrollable,
                'popup': caller === 'catalog-product-selector',
                'catalog-product-list__grid--small-columns': !responsive.lg && !showFilterButton,
                'catalog-product-list__grid' : (items.length >= 1),
                'search-notfound' : items.length === 0
      }"
      @reached-bottom="$emit('reached-bottom')"
    >
      <div v-if="items.length === 0 && !loading" class="no_matches">
        <div>
          <!-- <base-icon
            icon="search"
            style="margin: 20px;"
            class="icon-plus"
          /> -->
          <base-icon
            icon="icon-product"
            style="margin: 50% 20px 20px 30%; width: 56px;height: 56px;"
          />
          <br>
          <span style="font-family: 'SilkaLight'">
            No products available
          </span>
        </div>
      </div>
      <template v-else>
        <slot v-for="(item, index) in items" :index="index" :item="item" />
      </template>
      <template v-if="loading ">
        <base-skeleton
          v-for="n in 8"
          :key="n"
          :opacity="0 + (1 /n)"
          class="mb-0"
        >
          <div class="">
            <div
              class="skeleton__item"
              style="height: 320px"
            />
            <div
              class="skeleton__item mt-2"
              style="height: 80px"
            />
          </div>
        </base-skeleton>
      </template>
    </div>
    <div v-else-if="!facetLoading" class="select-facet">
      <p class="select-facet__title">
        Select Department
      </p>
      <p class="select-facet__subtitle">
        Please select a department from the inventory options below:
      </p>
      <span class="select-facet__button-container">
        <button
          v-for="(item, index) in facetsArray" :key="index" class="select-facet__button"
          @click="selectDepartment(item)"
        >
          {{ mapWear(item.name) }}
        </button>
      </span>
    </div>
    <div v-else>
      <div class="skeleton__filter ">
        <base-skeleton none class="skeleton__filter" />
      </div>
      <div class="spacer" />
      <base-skeleton none class="skeleton__first " />
      <div
        class="mt-2"
      />
      <base-skeleton
        none class="skeleton__second"
      />
      <span class="skeleton__row">
        <base-skeleton v-for="i in 3 " :key="i" class="skeleton__button">
          <div class="skeleton__block" />
        </base-skeleton>
      </span>
    </div>
  </div>
</template>

<script>
import responsive from '@/components/mixins/responsive';
import { EventBus } from '@/event-bus';
import _ from 'lodash';
import BaseSkeleton from '../../Base/BaseSkeleton.vue';

export default {
  name: 'CatalogProductList',
  components: { BaseSkeleton },
  mixins: [responsive],
  props: {
    displayTitle: {
      type: Boolean,
      default: true,
    },
    scrollable: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
    filters: {
      type: Array,
      default: () => [],
    },
    filtersLimit: {
      type: Number,
      default: 10,
    },
    showFilterButton: {
      type: Boolean,
      default: false,
    },
    hideFilterChips: {
      type: Boolean,
      default: false,
    },
    caller: {
      type: String,
      default: null,
    },
    search: {
      type: String,
      default: '',
    },
    numResults: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    showSearch: false,
    showFilterTags: true,
    isSorted: '',
    mainFacetValues: [],
  }),
  computed: {
    filtersLimited() {
      return this.filters;
    },
    showFilterChips() {
      return this.filters.length > 0;
    },
    selectedFacets() {
      return this.$store.getters['catalog/selectedFacets'];
    },
    facetLoading() {
      return this.$store.getters['catalog/facetLoading'];
    },
    computedMainFacets() {
      return this.$store.getters['catalog/facets'];
    },
    selectedFacetsName() {
      return this.$store.state.catalog.selectedFacetsName;
    },
    facetsArray() {
      let mainFacetItem = this.$store.getters['catalog/facets'];

      if (mainFacetItem && mainFacetItem.length > 0) {
        mainFacetItem = mainFacetItem.find((item) => item.main_facet === true);
      } else {
        return [];
      }
      return mainFacetItem.facet_values;
    },
  },
  mounted() {
    EventBus.$on('isSort', (val) => {
      this.isSorted = val;
    });
  },
  methods: {
    onSearch: _.debounce(($event) => {
      EventBus.$emit('searchFilterProduct', $event);
    }, 300),
    searchFocus(sjn) {
      console.log('heleleke', sjn);
    },
    btnSearch() {
      this.showFilterTags = false;
      this.showSearch = true;
    },
    cancelSearch() {
      this.showFilterTags = false;
      this.showSearch = false;
      this.hideFilterChips = false;
      this.showFilterTags = true;
      EventBus.$emit('searchFilterProduct', '');
    },
    mapWear(item) {
      if (item === 'MENSWEAR') return 'MENS';
      else if (item === 'WOMENSWEAR') return 'WOMENS';
      return item;
    },
    async selectDepartment(filter) {
      await this.$store.dispatch('catalog/toggleSelectedFilter', filter);
      if (this.selectedFacets.length > 0) {
        // const paramString = JSON.stringify(this.selectedFacets);
        const obj = {};
        for (let item = 0; item < this.selectedFacets.length; item += 1) {
          const facetValueId = this.selectedFacets[item];
          const facetName = this.selectedFacetsName[item].facet_name;
          if (!(facetName in obj)) {
            obj[facetName] = [facetValueId];
          } else {
            obj[facetName].push(facetValueId);
          }
        }
        Object.entries(obj).forEach(([k, v]) => {
          try {
            obj[k] = v.join(',');
          } catch (e) {
            console.log(e);
          }
        });
        this.$store.dispatch('catalog/fetchFacets', { specialHandling: false, additionalParams: obj });
      } else {
        this.$store.dispatch('catalog/fetchFacets', {});
      }
    },
  },

};
</script>

<style lang="scss" scoped>
.catalog-product-list {
  &__filter {
    display: flex;
    margin-bottom: 20px;
    margin-left: -3px; // Equal to base-chip margin-left
    margin-right: -3px; // Equal to base-chip margin-right
  }
  &__grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    grid-gap: 16px;

    &--scrollable {
      padding: 2px; // Compensate for shadow
      overflow-y: auto;
      max-height: calc(100vh - 240px);
      &.popup {
        //  max-height: 65vh;
         max-height: 442px;
      }
    }

    &--small-columns {
      grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
    }
  }

  &__clear-btn {
    border: none !important;
    background: none !important;
    font-family: 'SilkaLight';
    font-size: $font-size-s;
    padding: 3px 5px 0px 5px;
    height: 20px;
    display: inline-flex;
    min-width: 65px;
    cursor: pointer;
    color: #333333;
    vertical-align: top;

    &:hover{
      color: #282828 !important;
    }
  }
  &__filter-btn {
    margin-bottom: 20px;
    margin-right: 30px;
    margin-left: 0;
    padding-left: 0;
  }
}
.base-card-title__text {
    font-family: $font-family-timepos-headline;
    font-weight: 700;
    color: $black;
}
.catalog_sortby {
  justify-content: space-between !important;
  display: flex;
}
::v-deep .base-chip {
  border: 1px solid #C6C6C6;
  box-shadow: unset;
  border-radius: 4px;
  height: 20px;
}
.filter_count {
  margin-bottom: 8px;
  min-width: 50px;
  font-family: 'SilkaLight';
  font-size: 12px;
  color: #767676;
}
::v-deep .base-button {
  align-items: revert;
}
::v-deep .base-button--small {
  padding: 5px 5px 0px 0px;
}
::v-deep .base-icon {
  width: 14px;
}
::v-deep .base-dropdown__icon {
  width: 10px !important;
}
::v-deep .base-chip {
  margin: 0px 5px 8px 5px !important;
}
.search_button {
  margin-bottom: 13px;
  margin-top: -5px;
  width: 100%;
  margin-right: 11px;
  border-radius: 5px;
}
.no_matches {
  display: flex;
  justify-content: center;
  margin-top: 10%;
}
.search-notfound{
  background-color: #FAF9F7;
  height: 626px;
}
.action-close{
  right: 0%;
  margin-top: 5px;
  margin-right: 85px;
  cursor: pointer;
}
.action-close-sort{
  right: 3%;
  margin-right: unset;
}

.select-facet{
  &__title{
    font-weight: 500;
    font-size: 16px;
    padding-top: 20px;
    font-family: "SilkaMedium"
  }
  &__subtitle{
    font-weight: 300;
    font-size: 14px;
    font-family: $font-family-sans-serif-light
  }
  &__button{
    border-radius:4px;
    border: 1px #E2E2E2 solid;
    padding: 16px 10px 16px 10px;
    background-color : white;
    margin: 0 24px 0 0;
    font-weight: 300;
    color: #1B1B1B;
    width: 200px;
    font-size: 14px;
    font-family: $font-family-sans-serif-light;
  }
  &__button-container{
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    flex-direction: row;
    margin-top: 20px;
  }

}
.skeleton{
    display: block;
    &__search{
      min-width : 20%;
      max-width: 20%;
      min-height:40px;
    }
    &__first{
      min-width : 20%;
      max-width: 20%;
      height: 12.25px;
      margin: 0 24px 0 0;
      background-color: #e2e2e2;
      display:block;
    }
    &__second{
      min-width : 50%;
      max-width: 50%;
      display:block;
      margin: 0 24px 0 0;
      height:11px;
      background-color: #e2e2e2;
      display:block;
    }
    &__filter{
      float:right;
      width:25%;
      background-color: #e2e2e2;
      display:block;
      height:36px;
    }
    &__block{

    min-height: 20px;
    height:20px;
    background-color: #e2e2e2;
    display:block;

  }
  &__row{
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    flex-direction: row;
    margin-top: 20px;
  }
  &__button{
    margin: 0 24px 0 0;
    min-width: 200px;
    max-width: 200px;
    height:40px;
    background-color: #e2e2e2;
    display:block;
  }
  }
  .spacer{
    height: 70px;
    display:block;
  }

</style>
